import { useDispatch, useSelector } from 'react-redux';
import { modalSelector } from 'Store/modules/app/selectors';
import { hideModalAction } from 'Store/modules/app/actions';
import { CloseIcon } from 'Components/icons';
import { removeOverflow } from 'Styles/utils/utils';
import { ResultType } from 'Types/common';
import { ModalContainer, ModalContent, CloseButton } from './styles';

const FormEfirma = ({ data }: { data: ResultType }): JSX.Element => {
  const dispatch = useDispatch();
  const modal = useSelector(modalSelector);
  const closeModal = (): void => {
    removeOverflow();
    dispatch(hideModalAction());
  };
  const { Component, options } = modal;
  return (
    <ModalContainer>
      <ModalContent>
        {!options.noClose && (
          <CloseButton onClick={closeModal}>
            <CloseIcon />
          </CloseButton>
        )}
        <Component data={data} />
      </ModalContent>
    </ModalContainer>
  );
};

export default FormEfirma;
